import { TableColumnsType } from "antd";
import React from "react";
import ReusableTable from "../../../../../../global components/Table/Table";
import NoData from "../../../../../../global components/Table/NoData/NoData";
import { PieChart } from "../../../../../../global components/Icons/PieChart";
import { PaginatedUserReportType } from "../../../../../../libs/Utils/Types/Reports";
import dayjs from "dayjs";
import Unauthorised from "../../../../../../global components/Unauthorised";
type ColumnsType = {
  serialNumber: number;
  key: number;
  date: string;
  highUsageAccounts: number;
  newSignUps: number;
  activeAccount: number;
  inActiveAccount: number;
};
type PropType = {
  isLoading: boolean;
  dataSource: PaginatedUserReportType["data"];
  unauthorized: boolean | { title: string; message: string };
};
function UserReportTable({ dataSource, isLoading, unauthorized }: PropType) {
  const columns: TableColumnsType<ColumnsType> = [
    {
      title: "S/N",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (serialNumber: number) => <span>{serialNumber}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date: string) => <span>{date}</span>,
    },
    {
      title: "Active Account",
      dataIndex: "activeAccount",
      key: "activeAccount",
      render: (activeAccount: number) => <span>{activeAccount}</span>,
    },
    {
      title: "Inactive Account",
      dataIndex: "inActiveAccount",
      key: "inActiveAccount",
      render: (inActiveAccount: number) => <span>{inActiveAccount}</span>,
    },
    {
      title: "New Signups",
      dataIndex: "newSignUps",
      key: "newSignUps",
      render: (newSignUps: string) => <span>{newSignUps}</span>,
    },
    {
      title: "High-Usage Accounts",
      dataIndex: "highUsageAccounts",
      key: "highUsageAccounts",
      render: (highUsageAccounts: string) => <span>{highUsageAccounts}</span>,
    },
  ];
  const data: ColumnsType[] =
    dataSource.map((item, index) => ({
      activeAccount: item.activeUserCount,
      date: dayjs.utc(item.date).local().format("MMM DD, YYYY"),
      highUsageAccounts: item.highUsageAccountCount,
      inActiveAccount: item.inactiveUserCount,
      key: index,
      newSignUps: item.signupCount,
      serialNumber: index + 1,
    })) ?? [];
  return (
    <ReusableTable
      columns={columns}
      dataSource={data}
      loading={isLoading}
      noDataComponent={
        unauthorized ? (
          typeof unauthorized === "boolean" ? (
            <Unauthorised />
          ) : (
            <Unauthorised error={unauthorized} />
          )
        ) : (
          <NoData
            Message="No user report found"
            subMessage=""
            icon={<PieChart height={32} width={32} />}
          />
        )
      }
    />
  );
}

export default UserReportTable;
